const SocialColors = {
	discord: "#7289DA",
	instagram: "#E4405F",
	telegram: "#26A5E4",
	whatsapp: "#25D366",
	facebook: "#1877F2",
};

export default SocialColors;
